import React from 'react';

import { TypographyContextProvider } from '../Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import {
  parseMargin,
  parsePadding,
  parseSpacing,
} from '../../utils/parseSpacing';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';

import * as S from './styles';
import { LayoutSlotStoryblok } from '../../types/storyblok';

/**
 * Renders a <LayoutSlot /> component
 * @param {Object} props
 * @param {string} props.colourScheme
 * @param {string} props.content
 * @param {string} props.height
 * @param {boolean} props.hideDesktop
 * @param {boolean} props.hideMobile
 * @param {string} props.margin
 * @param {string} props.outsideMargin
 * @param {string} props.outsideWidth
 * @param {string} props.padding
 * @param {string} props.width
 */
const LayoutSlot = ({
  colourScheme,
  content,
  height,
  hideDesktop,
  hideMobile,
  margin,
  outsideMargin,
  outsideWidth,
  padding,
  width,
}: LayoutSlotStoryblok) => (
  <TypographyContextProvider value={{ colourScheme }}>
    <S.Wrapper
      $hideDesktop={hideDesktop}
      $hideMobile={hideMobile}
      backgroundColor={colourMatching(colourScheme)}
      flex="1"
      sx={{
        ...parseMargin(outsideMargin),
        minWidth: parseSpacing(outsideWidth),
        maxWidth: parseSpacing(outsideWidth),
      }}
    >
      <S.ContentWrapper
        sx={{
          ...parseMargin(margin),
          ...parsePadding(padding),
          height: parseSpacing(height),
          minWidth: parseSpacing(width),
          maxWidth: parseSpacing(width),
        }}
      >
        {renderStoryblokComponents({ blocks: content })}
      </S.ContentWrapper>
    </S.Wrapper>
  </TypographyContextProvider>
);

export default LayoutSlot;
